import * as Sentry from '@sentry/react';
import apiClient from '.';
import { getSwitchUser } from '../helpers/localStorage';

const login = async ({
    username,
    password,
}: {
    username: string;
    password: string;
}) => {
    Sentry.addBreadcrumb({
        category: 'Login',
        message: 'Authenticated user ' + username,
        // level: Sentry.Severity.Info,
    });
    return await apiClient.login(username, password);
};

const verifyOtp = async ({ code }: { code: string }) => {
    return await apiClient.respondToLoginChallenge(code);
};

const restoreSession = async () => {
    await apiClient.restoreSession();
    const switchUser = getSwitchUser();
    if (switchUser?.id) {
        apiClient.switchUser(Number(switchUser?.id));
    }
    return apiClient.session;
};

const logout = async () => {
    Sentry.addBreadcrumb({
        category: 'Logout',
        // level: Sentry.Severity.Info,
    });
    return await apiClient.logout();
};

const errorHandler = (err: any) => {
    const errorMsg: any = err?.response?.data?.error;
    return Array.isArray(errorMsg) ? errorMsg?.join('\n') : errorMsg;
};

const resetPassword = async (
    password: string,
    user: Record<string, string>
) => {
    const { getErrorMessage } = await import('@canopy-pte-ltd/canopy-toolkit');
    try {
        const { data: result } = await apiClient.post(`users/password/reset`, {
            data: {
                new_password: password,
                old_password: user.password,
            },
            apiVersion: 'v1',
            headers: {
                authorization: user.token,
            },
        });
        return result;
    } catch (e: any) {
        const error = getErrorMessage(errorHandler(e));
        if (error) {
            throw error;
        } else {
            throw 'unexpected-error';
        }
    }
};

const validatePassword = async (password: string, username: string) => {
    try {
        const { data: results } = await apiClient.post(`passwords/validate`, {
            data: { username, password },
            apiVersion: 'v1',
        });
        return results;
    } catch (e: any) {
        const { getErrorMessage } = await import(
            '@canopy-pte-ltd/canopy-toolkit'
        );
        const error = getErrorMessage(errorHandler(e) || e?.message);
        if (error) {
            throw error;
        } else {
            throw 'generic-problem';
        }
    }
};

export {
    login,
    validatePassword,
    resetPassword,
    logout,
    restoreSession,
    verifyOtp,
};
